<template>
  <div class="relative w-100">
    <div class="relative swiper-bg">
      <div class="relative mw8-25 center">
        <slot name="fixed-bg-contents"></slot>
        <!--
        <h3 class="f1 is-tablet-bold is-white lh-title">Find out more about<br class="dn db-ns">our luxury experiences</h3>
        <a class="db mw6 mt4 btn-generic has-red-bg">
          <span class="text">
            Luxury Lands
          </span>
        </a>
        -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      background:{},
      height:{},
    },
    data () {
      return {
        swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          initialSlide: 0,
          spaceBetween: 15,
          centeredSlides: true,
          freeMode: false,
          slidesPerView: 1,
        }
      }
    },
    computed: {
      accolades_carousel: function () {
        var accoladesData = this.$store.getters.filterPagesByName('accolades-carousel.markdown');
        return accoladesData[0];
      }
    },
    methods: {
      addBG: function() {
        return 'background-image:url('+this.background+');background-size:cover;background-position:bottom';
      }
    },
    created() {
      window.addEventListener('load', this.swiperInit);
      window.addEventListener('resize', this.swiperInit);
    },
    destroyed() {
      window.removeEventListener('load', this.swiperInit);
      window.removeEventListener('resize', this.swiperInit);
    }
  }
    
</script>